export enum FeatureFlag {
  SendTrackersToFreeze = "SendTrackersToFreeze",
  SendTrackersToHoming = "SendTrackersToHoming",
  ResetTrackers = "ResetTrackers",
  ForceTrackersElevation = "ForceTrackersElevation",
  ScheduledMaintenance = "ScheduledMaintenance",
  CamerasPage = "CamerasPage",
  IsAgriPageVisible = "IsAgriPageVisible",
  IsSprinklersFeatureEnabled = "IsSprinklersFeatureEnabled",
  IsIssuesFeatureEnabled = "IsIssuesFeatureEnabled",
  IsUserRecordFeatureEnabled = "IsUserRecordFeatureEnabled",
  IsQueryHistoryForMoreThanOneWeekEnabled = "IsQueryHistoryForMoreThanOneWeekEnabled",
  IsAiChatAgentEnabled = "IsAiChatAgentEnabled",
  IsInverterCloudReadingsEnabled = "IsInverterCloudReadingsEnabled",
  IsSettingsPageEnabled = "IsSettingsPageEnabled",
  DeploymentPage = "DeploymentPage",
  CommissioningMode = "CommissioningMode",
  TrackerComponentReplacement = "TrackerComponentReplacement",
  ReportsPage = "ReportsPage",
  DiffuseOptimization = "DiffuseOptimization",
  MapViewGeographicBackground = "MapViewGeographicBackground",
}

export const FeatureFlagOverrideDisplayName: Partial<Record<FeatureFlag, string>> = {
  [FeatureFlag.IsAgriPageVisible]: "Agri page",
  [FeatureFlag.IsSprinklersFeatureEnabled]: "Faucets page",
  [FeatureFlag.IsIssuesFeatureEnabled]: "Alerts page",
  [FeatureFlag.IsUserRecordFeatureEnabled]: "Activity Log page",
  [FeatureFlag.IsQueryHistoryForMoreThanOneWeekEnabled]: "Query history for more than a week",
  [FeatureFlag.DeploymentPage]: "Deployments page",
  [FeatureFlag.ReportsPage]: "Reports page",
  [FeatureFlag.MapViewGeographicBackground]: "Map view aerial background",
};

export interface ISitesFeatureFlagsDictionary {
  [siteId: string]: FeatureFlag[];
}

export const normalizeFeatureFlags = (
  apiResponse: ISitesFeatureFlagsDictionary
): ISitesFeatureFlagsDictionary => {
  return Object.entries(apiResponse).reduce((normalized, [siteId, flags]) => {
    const validFlags = new Set<FeatureFlag>();
    for (const flag of flags) {
      if (Object.values(FeatureFlag).includes(flag)) {
        validFlags.add(flag);
      }
    }
    normalized[siteId] = [...validFlags];
    return normalized;
  }, {} as ISitesFeatureFlagsDictionary);
};
